
import { CATEGORY, COLOR, COLUMN, CMTES, COMMITTEE, DATES, FORMATTING, LAYOUT, SEX, SEX_ENUM } from "../../modules/constants"
import { getStatusLevel, getNameProp } from "../../modules/utilities"
import { addPaddingRightToLastCell, getCellWithTooltip } from "../../modules/table.funcs"
import { getOverlapCell2 } from "./NexusTableFunctions"

const { border1, black, string } = FORMATTING
const chair = 1
const member = 2

export const getNexusCommitteeRowFromCapacity = props => {
  // console.log('getRowFromCapacity props:', props)
  const { columns, committeeStatus, isCompany, item, maxLseData, portrait, role, stats, the350club } = props
  // console.log('stats2:',stats2)
  role.connectionStart = new Date(role.from)
  // if no resigned date available, set to DATES.FUTURE so that connectionEnd can be identified accordingly (using FUTURE_YEAR) in table.funcs, and used for sorting
  role.connectionEnd = role.until ? new Date(role.until) : DATES.FUTURE

  const cell = {
    //#region get the cells
    [isCompany ? COLUMN.OFFICER : COLUMN.COMPANY]: getNameCell(item),
    [COLUMN.ROLE]: getRoleCell({ role, maxLseData }),
    [COLUMN.TENURE]: getOverlapCell2(item, stats),
  }
  const borderLeft = portrait ? null : border1

  // getCommitteeCell adds props to 'cell'
  getCommitteeCell({ borderLeft, cell, committees: role.cmtes, cmte: CMTES.AUD, committeeStatus, id: COLUMN.COMMITTEE.AUDIT, portrait, stats })
  getCommitteeCell({ borderLeft, cell, committees: role.cmtes, cmte: CMTES.REM, committeeStatus, id: COLUMN.COMMITTEE.REMUNERATION, portrait, stats })
  getCommitteeCell({ borderLeft, cell, committees: role.cmtes, cmte: CMTES.NOM, committeeStatus, id: COLUMN.COMMITTEE.NOMINATION, portrait, stats })

  const row = getRow({ ...props, cell })

  row.cellWithTooltips = getCommitteesCellWithTooltip({ cell, columns })

  addPaddingRightToLastCell(row.cellWithTooltips)

  // 350 club has no star icon so we need to add padding
  // (icon is added in NumerableTable)
  if (the350club)
    row.cellWithTooltips[0].paddingLeft = LAYOUT.COLUMN_PADDING

  return row
}

const getRow = ({ item, maxLseData }) => ({
  _id: item.entity._id,
  iconColor: (maxLseData || item.entity.category === CATEGORY.COMPANY) ? getStatusColor(item) : black,
  index: item.index,
  isFavourite: item.entity.isFavourite,
  link: getLink(item),
})

const getCommitteesCellWithTooltip = ({ cell, columns }) => {
  const cells = []

  // Add cells to the array in accordance to the properties on 'columns' - defined on Nexus page
  for (const [key, value] of Object.entries(columns))
    if (value && cell[parseInt(key)])
      cells.push(cell[parseInt(key)])

  return cells
}

const getStatusColor = item => item.entity.category === CATEGORY.COMPANY
  ? COLOR[getStatusLevel(item.entity.companyProps.status)] // company
  : item.entity.personInfo?.sex == SEX_ENUM.MALE || item.entity.personInfo?.sex == SEX_ENUM.FEMALE // person
    ? SEX[item.entity.personInfo.sex].COLOR
    : SEX[SEX_ENUM.UNKNOWN].COLOR

const getNameCell = item =>
  getCellWithTooltip({
    sortValue: getNameProp.toSort(item.entity?.name),
    type: string,
    value: getNameProp.toPresent(item.entity?.name),
  })

const committeeName = {
  [CMTES.AUD]: COMMITTEE.AUDIT,
  [CMTES.REM]: COMMITTEE.REMCOM,
  [CMTES.NOM]: COMMITTEE.NOMCOM,
}

const backgroundColor = COMMITTEE.NONEXISTANT.COLOR

// committees eg {aud: 1, rem: null, nom: 2} - (1 is chair, 2 is member)
// cmte eg 'aud' (CMTES.AUD)
// committeeStatus eg {aud: true, rem: false, nom: true, name: 'F&C INVESTMENT TRUST PLC'}
const getCommitteeCell = props => {
  // console.log('getCommitteeCell3 props:', props)
  const { borderLeft = null, cell, cmte, committees, committeeStatus, id, portrait, stats } = props
  var tooltip = ` ${committeeStatus?.name} has no ${committeeName[cmte]} Committee`
  if (committeeStatus && committeeStatus[cmte] === false) {
    cell[id.CHAIRS] = { backgroundColor, borderLeft, tooltip }
    cell[id.MEMBER] = { backgroundColor, tooltip }
  } else {
    cell[id.CHAIRS] = getCellWithTooltip(getCommitteeCellObject({ borderLeft, committees, cmte, role: chair, portrait, stats }))
    cell[id.MEMBER] = getCellWithTooltip(getCommitteeCellObject({ committees, cmte, role: member, stats }))
  }
}

// Returns the committee cell object
const getCommitteeCellObject = props => {
  // console.log('getCommitteeCellObject props:',props)
  const { borderLeft = null, committees, cmte, role, stats } = props
  const committee = committees?.[cmte]
  // console.log('getCommitteeCellObject committee:', committee, '  role:', role)
  // ie if committees.aud is 2 (member) and role is 2 (member) we set value to a tick
  if (committee === role) {
    // create the stats obejct name eg for cmte 'aud' and role 2,
    // 1st char or 'aud' is 'a', plus index 2 of ['', 'c', 'm'] is 'm = 'am'
    stats[cmte.charAt(0) + ['', 'c', 'm'][role]].total++

    return {
      align: LAYOUT.COMMITTEE.ALIGNMENT,
      borderLeft,
      paddingLeft: LAYOUT.COLUMN_PADDING,
      paddingRight: LAYOUT.COLUMN_PADDING,
      sortValue: 0,
      type: string,
      value: LAYOUT.TICK,
    }
  }
  else return {
    borderLeft,
    sortValue: 1,
  }
}

const getRoleCell = ({ role, maxLseData }) =>
  getCellWithTooltip({
    type: string,
    value: (maxLseData ? role.position.title : role.roleDescription)
  })

const getLink = item => `/${item.entity.category || item.category.keyValues["category"]}/${item.entity.ids.join(",")}`